/*
 * types/services/collection.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';

/**
 * The ListCollectionRequestPaginate model module.
 * @module model/ListCollectionRequestPaginate
 * @version version not set
 */
export class ListCollectionRequestPaginate {
  /**
   * Constructs a new <code>ListCollectionRequestPaginate</code>.
   * @alias module:model/ListCollectionRequestPaginate
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ListCollectionRequestPaginate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ListCollectionRequestPaginate} obj Optional instance to populate.
   * @return {module:model/ListCollectionRequestPaginate} The populated <code>ListCollectionRequestPaginate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ListCollectionRequestPaginate();
      if (data.hasOwnProperty('offset'))
        obj.offset = ApiClient.convertToType(data['offset'], 'Number');
      if (data.hasOwnProperty('limit'))
        obj.limit = ApiClient.convertToType(data['limit'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} offset
 */
ListCollectionRequestPaginate.prototype.offset = undefined;

/**
 * @member {Number} limit
 */
ListCollectionRequestPaginate.prototype.limit = undefined;


